import React, { useEffect, useState } from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import increaseRevenueIcon from "./../../../assets/increase_revenue.svg";
import calendarIcon from "./../../../assets/calendar.svg";
import { NumericFormat } from "react-number-format";
import useRoi from "../../../Context/RoiContex";
import { calculateReduction } from "../../../api/ApiService";
import Card from "../../Card/Card";

function ReduceNoShow() {
  const { updateNoShowData, reduceNoShowInputValue } = useRoi();
  const [inputValue, setInputValue] = useState(reduceNoShowInputValue);

  const {
    monthlyAppointments,
    averageOrderValueEachPatientPerVisitOrPatientTicketSize,
    updateNoShowInputValue,
  } = useRoi();

  const [noShowDataLocalState, setNoShowData] = useState({
    monthlyAppointmentIncrease: 0,
    averageAdditionalRevenuePerMonth: 0,
    averageAdditionalRevenueInYear: 0,
  });

  useEffect(() => {
    const getInitialData = async () => {
      try {
        const param = {
          averageOrderValueEachPatientPerVisitOrPatientTicketSize: parseInt(
            averageOrderValueEachPatientPerVisitOrPatientTicketSize
          ),
          monthlyAppointments: monthlyAppointments,
          noShows: inputValue / 100,
        };
        const response = await calculateReduction(param);
        updateNoShowData(response);
        setNoShowData(response);
      } catch (error) {
        console.error("Error fetching staff data:", error);
      } finally {
      }
    };
    getInitialData();
  }, [inputValue, monthlyAppointments, averageOrderValueEachPatientPerVisitOrPatientTicketSize]);

  const onSliderChange = (value) => {
    setInputValue(value);
    updateNoShowInputValue(value);
  };

  return (
    <div className="mx-0" style={{ marginLeft: "6px" }}>
      <div className="w-full">
        <div className="flex justify-between h-[62px] items-center mt-2">
          <label htmlFor="collecton-agency" className="text-lg text-[#1A1A1A] font-semibold">
            Percentage of no-shows
          </label>
          <div style={{marginTop: "24px"}}>
            <NumericFormat
              id="collecton-agency"
              name="collecton-agency"
              value={inputValue}
              onValueChange={(values) => {
                const { value } = values;
                setInputValue(value);
                updateNoShowInputValue(value);
              }}
              suffix="%"
              allowNegative={false}
              className="ha-roi-form-input"
            />
          </div>
        </div>
        <div style={{ position: "relative", top: "20px" }}>
          <Slider
            min={0}
            max={100}
            value={inputValue}
            trackStyle={{ backgroundColor: "#147D6E" }}
            handleStyle={{
              borderColor: "#147D6E",
              backgroundColor: "#147D6E",
            }}
            onChange={onSliderChange}
          />
        </div>
      </div>
      <p className="text-xl font-bold mt-6" style={{ marginTop: "40px" }}>
        By optimizing workflows, you increase:
      </p>
      {noShowDataLocalState && (
        <div className="flex  gap-5 w-full  my-4 second-second-card">
          <Card
            type="value"
            icon={calendarIcon}
            message="appointments per month"
            value={noShowDataLocalState.monthlyAppointmentIncrease}
            color="#71B254"
          />
          <Card
            icon={increaseRevenueIcon}
            message="in annual revenue"
            value={noShowDataLocalState.averageAdditionalRevenueInYear}
            color="#147D6E"
          />
        </div>
      )}
    </div>
  );
}

export default ReduceNoShow;
